(function ($) {
  'use strict';

  var classNames = {
    loading: 'btn-warning',
    error: 'btn-danger',
  };

  $(document).ready(function () {
    bindToggleClick();
  });

  function bindToggleClick() {
    $('body').on(
      'click',
      '[data-role="data-expand-toggle"]',
      onToggleClick,
    );
  }

  function onToggleClick(e) {
    var element = $(this),
      scope,
      requestUrl,
      target,
      offset,
      limit;
    scope = element.attr('data-scope');
    requestUrl = element.attr('data-req');
    offset = parseInt(element.attr('data-offset'), 10);
    limit = parseInt(element.attr('data-limit'), 10);
    target = $(
      '[data-role="data-expand-target"][data-scope="' + scope + '"]',
    );
    element.addClass(classNames.loading);
    sendRequest(requestUrl, element, target, limit, offset);
    e.preventDefault();
  }

  function sendRequest(url, toggle, target, limit, offset) {
    $.get(url, { offset: offset }).complete(function (response) {
      onResponse(response, toggle, target, limit, offset);
    });
  }

  function onResponse(response, toggle, target, limit, offset) {
    if (response.status === 200) {
      onRequestSuccess(
        response.responseText,
        toggle,
        target,
        limit,
        offset,
      );
    } else {
      onRequestError(toggle, target);
    }
  }

  function onRequestSuccess(data, toggle, target, limit, offset) {
    toggle.attr('data-offset', offset + limit);
    toggle.removeClass(classNames.loading).removeClass(classNames.error);
    target.append(data);
  }

  function onRequestError(toggle) {
    toggle.removeClass(classNames.loading);
    toggle.addClass(classNames.error);
  }
})(jQuery);
